
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserInterface } from '@/services/Users/Interfaces';
import UsersRepo from '@/services/Users';

@Component({
  inject: [
    'userRepository',
  ],
})
export default class DeleteUserDialog extends Vue {
  private readonly userRepository!: UsersRepo;

  @Prop() private readonly user!: UserInterface;

  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete ${this.user.username}(${this.user.email})?`;
  }

  private async deleteUser(): Promise<void> {
    try {
      await this.userRepository.deleteUser(this.user.id);
      this.$successDialog.show(`User ${this.user.username}(${this.user.email}) has been deleted.`);
      this.$emit('deleted-user');
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
      this.destroyComponent();
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
